// extracted by mini-css-extract-plugin
export default {"container":"kq-z","heading":"lq-z","text":"mq-z","info":"nq-z","link":"oq-z","fullMaxWidth":"pq-z"};